import React, { useState, useEffect } from "react";
import { LuWallet } from "react-icons/lu";
import { PiUsers } from "react-icons/pi";
import { CiLocationOn } from "react-icons/ci";
import { MdOutlineAccessTime } from "react-icons/md";
import { useNavigate, NavLink, Link } from 'react-router-dom';
import { FaStar, FaRegStar } from "react-icons/fa";
import { TbMoneybag } from "react-icons/tb";
import { Nav, Button, Container, Col, Form, Row } from 'react-bootstrap';
import Footer from '../Footer/Footer';


const ServicesList = [
  {
    id: 1,
    name: 'Veritis Development Agency',
    image: 'https://media.licdn.com/dms/image/v2/C510BAQHna_dD9vpNKg/company-logo_200_200/company-logo_200_200/0/1630628710289/veritis_group_inc_logo?e=2147483647&v=beta&t=8UDgYse3wANLmwRZ5JUULSvEFt7tOwLR8mQjtHkiAc4',
    staff: '10 - 49',
    location: 'New York, USA',
    budget: '$25,000+',
    hourrate: '$50 - $99/hr',
    rating: 4.5,
    review: 26,
    description: 'Veritis is a global Information Technology (IT) consulting services provider focused on delivering high value to clients through integrated, reliable and cost-effective solutions. The major service lines that we focus on are Cloud, Containerization, DevOps, Digital Transformation, Managed IT Services, and Technology Advisory Services. We at Veritis gauge our success by our customers’ success. We regard it as a privilege to serve our customers and are committed to doing whatever it takes to ensure they are 100 percent satisfied.',
    services: ['Website Development', 'App Development', 'Development', 'AWS', 'Azure', 'Design']
  },

  {
    id: 2,
    name: 'Aevitas Development Agency',
    image: 'https://img.freepik.com/free-vector/colorful-letter-gradient-logo-design_474888-2309.jpg',
    staff: '10 - 49',
    location: 'New York, USA',
    budget: '$25,000+',
    hourrate: '$50 - $99/hr',
    rating: 4.9,
    review: 262,
    description: 'Veritis is a global Information Technology (IT) consulting services provider focused on delivering high value to clients through integrated, reliable and cost-effective solutions. The major service lines that we focus on are Cloud, Containerization, DevOps, Digital Transformation, Managed IT Services, and Technology Advisory Services. We at Veritis gauge our success by our customers’ success. We regard it as a privilege to serve our customers and are committed to doing whatever it takes to ensure they are 100 percent satisfied.',
    services: ['Website Development', 'App Development', 'Development', 'AWS', 'Azure', 'Design']
  },

  {
    id: 3,
    name: 'Oractel Data Solutions',
    image: 'https://cryptologos.cc/logos/arbitrum-arb-logo.png',
    staff: '10 - 49',
    location: 'New York, USA',
    budget: '$25,000+',
    hourrate: '$50 - $99/hr',
    rating: 4.2,
    review: 32,
    description: 'Veritis is a global Information Technology (IT) consulting services provider focused on delivering high value to clients through integrated, reliable and cost-effective solutions. The major service lines that we focus on are Cloud, Containerization, DevOps, Digital Transformation, Managed IT Services, and Technology Advisory Services. We at Veritis gauge our success by our customers’ success. We regard it as a privilege to serve our customers and are committed to doing whatever it takes to ensure they are 100 percent satisfied.',
    services: ['Website Development', 'App Development', 'Development', 'AWS', 'Azure', 'Design']
  },

  {
    id: 4,
    name: 'ITR Mobile Solutions',
    image: 'https://www.logoai.com/oss/icons/2021/10/27/MuCSnBxFpOQg2Kl.png',
    staff: '10 - 49',
    location: 'New York, USA',
    budget: '$25,000+',
    hourrate: '$50 - $99/hr',
    rating: 3.9,
    review: 125,
    description: 'Veritis is a global Information Technology (IT) consulting services provider focused on delivering high value to clients through integrated, reliable and cost-effective solutions. The major service lines that we focus on are Cloud, Containerization, DevOps, Digital Transformation, Managed IT Services, and Technology Advisory Services. We at Veritis gauge our success by our customers’ success. We regard it as a privilege to serve our customers and are committed to doing whatever it takes to ensure they are 100 percent satisfied.',
    services: ['Website Development', 'App Development', 'Development', 'AWS', 'Azure', 'Design']
  },

  {
    id: 5,
    name: 'Gtech Corporation',
    image: 'https://www.logoai.com/oss/icons/2021/10/27/VgRTHEL8YOYKnCn.png',
    staff: '10 - 49',
    location: 'New York, USA',
    budget: '$25,000+',
    hourrate: '$50 - $99/hr',
    rating: 4.1,
    review: 200,
    description: 'Veritis is a global Information Technology (IT) consulting services provider focused on delivering high value to clients through integrated, reliable and cost-effective solutions. The major service lines that we focus on are Cloud, Containerization, DevOps, Digital Transformation, Managed IT Services, and Technology Advisory Services. We at Veritis gauge our success by our customers’ success. We regard it as a privilege to serve our customers and are committed to doing whatever it takes to ensure they are 100 percent satisfied.',
    services: ['Website Development', 'App Development', 'Development', 'AWS', 'Azure', 'Design']
  },
];


function MyShortlist() {
  const navigate = useNavigate();
  const [bookmarked, setBookmarked] = useState(false);
  const [filters, setFilters] = useState({
    location: '',
    service: '',
    hourlyRate: '',
    employees: '',
    reviews: ''
  });



  const toggleBookmark = () => {
    setBookmarked(!bookmarked);
  };

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const [showCanvas, setShowCanvas] = useState(false);
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    projectTitle: "",
    projectDescription: "",
    startDate: "",
    budget: "",
    company: "",
    contactName: "",
    email: "",
    phone: "",
    projectType: ""
  });
  const [errors, setErrors] = useState({});

  const projectTypes = ["Web Development", "Mobile App Development", "SEO", "Graphic Design"];

  useEffect(() => {
    setShowCanvas(false);
  }, []);


  const validate = () => {
    let newErrors = {};
    if (!formData.projectType) newErrors.projectType = "Project type is required";
    if (!formData.projectTitle) newErrors.projectTitle = "Project title is required";
    if (!formData.projectDescription) newErrors.projectDescription = "Project description is required";
    if (!formData.startDate) newErrors.startDate = "Start date is required";
    if (!formData.budget) newErrors.budget = "Budget is required";
    if (!formData.company) newErrors.company = "Company is required";
    if (!formData.contactName) newErrors.contactName = "Contact name is required";
    if (!formData.email) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) newErrors.email = "Invalid email format";
    if (!formData.phone) newErrors.phone = "Phone number is required";


    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const nextStep = () => {
    setStep((prevStep) => prevStep + 1);
  };



  const prevStep = () => setStep(step - 1);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [selectedFilters, setSelectedFilters] = useState({
    service: [],
    budget: [],
    location: [],
    employees: [],
    reviews: [],
    hourlyRate: [],
  });


  // Options for the multi-select dropdowns
  const serviceOptions = [
    { value: "web-development", label: "Web Development" },
    { value: "mobile-apps", label: "Mobile Apps" },
    { value: "seo", label: "SEO" },
  ];

  const budgetOptions = [
    { value: "0-1000", label: "$0 - $1000" },
    { value: "1000-5000", label: "$1000 - $5000" },
    { value: "5000-10000", label: "$5000 - $10,000" },
  ];

  const locationOptions = [
    { value: "usa", label: "USA" },
    { value: "uk", label: "UK" },
    { value: "india", label: "India" },
  ];

  const employeeOptions = [
    { value: "1-10", label: "1-10" },
    { value: "11-50", label: "11-50" },
    { value: "51-200", label: "51-200" },
  ];

  const reviewOptions = [
    { value: "4star", label: "4 Stars & Above" },
    { value: "3star", label: "3 Stars & Above" },
    { value: "2star", label: "2 Stars & Above" },
  ];

  const hourlyRateOptions = [
    { value: "10-20", label: "$10 - $20" },
    { value: "20-50", label: "$20 - $50" },
    { value: "50-100", label: "$50 - $100" },
  ];

  // Function to handle multi-select change
  const filterhandleChange = (selectedOptions, { name }) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [name]: selectedOptions ? selectedOptions.map((option) => option.value) : [],
    }));
  };


  return (
    <>





          <div className="js-pg-hg mt-3">
      <div className="container mt-4 mb-4">

      <div className="row justify-content-center">
        <div className="col-lg-12">
          <div className="heading mb-4 pb-1">
            <h6 className="card-title text-primary mb-2">Welcome Veritis!</h6>
            <h4>My Shortlist</h4>
          </div>
          </div>
        </div>


        <div className="row">
          {ServicesList.map(profile => (
            <div className='col-12 mb-4' key={profile.id}>
              <div className="d-lg-flex card rounded-4 align-items-stretch p-4">
                <div className='flex-grow-1'>
                  <div className='d-flex justify-content-between'>
                    <div className='d-flex align-items-center mb-4'>
                      <img src={profile.image} className="img-thumbnail rounded-3 border-1 me-4" alt={profile.name} style={{ maxWidth: '80px' }} />
                      <div>
                        <h5 className="card-title pb-1" style={{ cursor: 'pointer' }}>
                          {profile.name}                            <span className="ms-3 small verify py-1 rounded-4 fs-6 p-2 text-success"><i class='bx text-success bxs-check-circle' ></i> Verified</span>
                        </h5>
                        <span className="card-text rating">
                          <strong className="me-2"> {profile.rating}</strong>
                          {[...Array(5)].map((_, index) =>
                            index < profile.rating ? (
                              <FaStar key={index} className="text-warning" />
                            ) : (
                              <FaRegStar key={index} className="text-warning" />
                            )
                          )}
                          <span className="ms-3 small">(26 Reviews)</span>
                        </span>
                      </div>
                    </div>

                    <div>

                      <button className='btn fs-2 p-0 m-0 pt-2 me-3 icon-clr' onClick={toggleBookmark}>
                        <i class='bx bxs-bookmark text-primary'></i>     </button>
                      <button className='btn fs-2 p-0 m-0 pt-2 me-3 icon-clr' onClick={toggleBookmark}>
                        <i class='bx bxs-check-shield' ></i>
                      </button>
                      <Button className="btn btn-md btn-primary" onClick={() => setShowCanvas(true)} >Hire Us</Button>
                    </div>
                  </div>

                  <div className='d-flex justify-content-between align-items-center border-top pt-3'>
                    <div className="d-flex">
                      <p className="fw-500 mt-3 me-4">
                        <TbMoneybag className="me-2 text-primary fs-5" /> {profile.budget}
                      </p>
                      <p className="fw-500 mt-3 me-4">
                        <MdOutlineAccessTime className="me-2 text-primary fs-5" /> {profile.hourrate}
                      </p>
                      <p className="fw-500 mt-3 me-4">
                        <PiUsers className="me-2 text-primary fs-5" /> {profile.staff}
                      </p>
                      <p className="fw-500 mt-3">
                        <CiLocationOn className="me-2 text-primary fs-5" /> {profile.location}
                      </p>
                    </div>

                    <div className="mt-1">
                      {/* <button className='btn btn-outline-primary text-primary me-2'>I'm Interested</button> */}
                      <NavLink to="/CompnayProfileDetailed" className="btn btn-outline-primary text-primary me-3">View Profile</NavLink>
                      <button className='btn btn-outline-primary text-primary'>Visit Website</button>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          ))}


          <div className="d-flex justify-content-between align-items-center p-3 mb-5">
            <div className="text-muted">Showing 10 of 215</div>
            <nav aria-label="Page navigation">
              <ul className="pagination mb-0">
                <li className="page-item disabled">
                  <button className="page-link">Previous</button>
                </li>
                <li className="page-item active">
                  <button className="page-link">1</button>
                </li>
                <li className="page-item">
                  <button className="page-link">2</button>
                </li>
                <li className="page-item">
                  <button className="page-link">3</button>
                </li>
                <li className="page-item">
                  <button className="page-link">Next</button>
                </li>
              </ul>
            </nav>
          </div>

        </div>

      </div>


      {/* Offcanvas from Right Side */}
      <div
        className={`offcanvas offcanvas-end ${showCanvas ? "show" : ""}`}
        tabIndex="-1"
        style={{ visibility: showCanvas ? "visible" : "hidden", width: "600px" }}
      >
        <div className="offcanvas-header px-5 pt-4">
          <h3 className="offcanvas-title">Hire Us</h3>
          <button type="button" className="btn-close" onClick={() => setShowCanvas(false)}></button>
        </div>
        <div className="offcanvas-body px-5">

          <div className="d-flex align-items-center p-3 border bg-light rounded-4">
            <img
              src="https://media.licdn.com/dms/image/v2/C510BAQHna_dD9vpNKg/company-logo_200_200/company-logo_200_200/0/1630628710289/veritis_group_inc_logo?e=2147483647&v=beta&t=8UDgYse3wANLmwRZ5JUULSvEFt7tOwLR8mQjtHkiAc4"
              alt="Veritis Development Agency"
              className="img-thumbnail rounded-3 border me-3"
              style={{ maxWidth: "80px" }}
            />
            <div>
              <h5 className="card-title pb-2" style={{ cursor: "pointer" }}>
                Veritis Development Agency
              </h5>
              <span className="card-text">
                <strong className="me-2"> 4.5</strong>
                {[...Array(5)].map((_, index) =>
                  index < 5 ? (
                    <FaStar key={index} className="text-warning" />
                  ) : (
                    <FaRegStar key={index} className="text-warning" />
                  )
                )}
                <span className="ms-3 small">(26 Reviews)</span>
              </span>



            </div>
          </div>

          <div className="pt-2">

            <div className="d-flex align-items-center justify-content-between mb-4 position-relative border rounded-3 p-3 mt-4">
              {["Project Info", "Contact Info", "Preview"].map((stepTitle, index) => (
                <div key={index} className="position-relative d-flex flex-column align-items-center flex-grow-1">
                  {/* Connector Line */}
                  {index !== 0 && (
                    <div className="position-absolute top-50 start-0 w-100 border-bottom border-dashed border-secondary"
                      style={{ left: '50%', transform: 'translateX(-50%)', zIndex: -1 }}></div>
                  )}
                  <div className={`badge d-flex fs-6 align-items-center p-2 px-3
        ${step > index + 1 ? 'bg-success text-white' : step === index + 1 ? 'border-primary bg-white text-primary' : 'bg-light text-dark'}`}>
                    {stepTitle}
                  </div>
                </div>
              ))}
            </div>

            {/* Step 1: Project Information */}
            {step === 1 && (
              <>

                <h5 className="py-3">Project Information</h5>

                <Form>
                  {/* Project Type */}
                  <Form.Group className="mb-4">
                    <Form.Label>Project Type</Form.Label>
                    <Form.Select name="projectType" value={formData.projectType} onChange={handleChange}>
                      <option value="">Select Project Type</option>
                      {projectTypes.map((type, index) => (
                        <option key={index} value={type}>{type}</option>
                      ))}
                    </Form.Select>
                    {errors.projectType && <div className="text-danger">{errors.projectType}</div>}
                  </Form.Group>

                  {/* Project Title */}
                  <Form.Group className="mb-4">
                    <Form.Label>Project Title</Form.Label>
                    <Form.Control type="text" name="projectTitle" value={formData.projectTitle} onChange={handleChange} />
                    {errors.projectTitle && <div className="text-danger">{errors.projectTitle}</div>}
                  </Form.Group>

                  {/* Project Description */}
                  <Form.Group className="mb-4">
                    <Form.Label>Project Description</Form.Label>
                    <Form.Control as="textarea" rows={3} name="projectDescription" value={formData.projectDescription} onChange={handleChange} />
                    {errors.projectDescription && <div className="text-danger">{errors.projectDescription}</div>}
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>Start From</Form.Label>
                    <Form.Select name="startDate" value={formData.startDate} onChange={handleChange}>
                      <option value="">Select Start Time</option>
                      <option value="immediately">Immediately</option>
                      <option value="lessThan15">Less than 15 Days</option>
                      <option value="15to30">15-30 Days</option>
                      <option value="30to60">30-60 Days</option>
                    </Form.Select>
                    {errors.startDate && <div className="text-danger">{errors.startDate}</div>}
                  </Form.Group>

                  {/* Budget */}
                  <Form.Group className="mb-4">
                    <Form.Label>Budget</Form.Label>
                    <Form.Select name="budget" value={formData.budget} onChange={handleChange}>
                      <option value="">Select Budget</option>
                      <option value="$10,000-20,000">$10,000-20,000</option>
                      <option value="$20,000-40,000">$20,000-40,000</option>
                      <option value="$40,000-60,000">$40,000-60,000</option>
                    </Form.Select>
                    {errors.budget && <div className="text-danger">{errors.budget}</div>}
                  </Form.Group>

                  <Button className="btn btn-primary mt-2" onClick={nextStep}>Continue</Button>
                </Form>
              </>
            )}

            {/* Step 2: Timeline & Contacts */}
            {step === 2 && (
              <>
                <h5 className="py-3">Your Information</h5>

                <Form>

                  <Form.Group className="mb-4">
                    <Form.Label>Company Name</Form.Label>
                    <Form.Control type="text" name="company" value={formData.company} onChange={handleChange} />
                    {errors.company && <div className="text-danger">{errors.company}</div>}
                  </Form.Group>




                  {/* Contact Name */}
                  <Form.Group className="mb-4">
                    <Form.Label>Your Full Name</Form.Label>
                    <Form.Control type="text" name="contactName" value={formData.contactName} onChange={handleChange} />
                    {errors.contactName && <div className="text-danger">{errors.contactName}</div>}
                  </Form.Group>

                  {/* Email */}
                  <Form.Group className="mb-4">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} />
                    {errors.email && <div className="text-danger">{errors.email}</div>}
                  </Form.Group>

                  {/* Phone */}
                  <Form.Group className="mb-4">
                    <Form.Label>Phone</Form.Label>
                    <Form.Control type="text" name="phone" value={formData.phone} onChange={handleChange} />
                    {errors.phone && <div className="text-danger">{errors.phone}</div>}
                  </Form.Group>

                  <button className="btn btn-outline-primary text-primary me-3" onClick={prevStep}>Back</button>
                  <button className="btn btn-primary" onClick={nextStep}>Continue</button>
                </Form>
              </>
            )}

            {/* Step 3: Preview */}
            {step === 3 && (
              <>
                <h5 className="py-3">Review & Submit</h5>
                {Object.entries(formData).map(([key, value]) => (
                  <p key={key} className="pt-2 pb-3 m-0 mb-2 border-bottom"><span class="text-muted small d-block">{key.replace(/([A-Z])/g, " $1").toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())}:</span><span class="d-block fs-6 pt-2">{value}</span></p>
                ))}
                <button className="btn btn-outline-primary mt-3 text-primary me-3" onClick={prevStep}>Back</button>
                <button className="btn btn-primary mt-3" onClick={nextStep}>Submit</button>
              </>
            )}

            {/* Step 4: Submitted */}
            {step === 4 && (
              <>
                <div className="text-center border rounded-4 p-5">
                  <h3 className="mb-4">Congratulations! 🎉</h3>
                  <p>Your request has been successfully submitted as a proposal.</p>
                  <button className="btn btn-outline-primary  mt-3 text-primary me-3">Close</button>
                  <Button className="btn btn-primary mt-3" as={Link} to="/noncompanyprofile" >View Proposals</Button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <Footer />

      </div>
    </>
  );
}
export default MyShortlist;
